module.exports = __webpack_public_path__ + "media/Enterprises-move-together.03765045.mp4";